import { classes } from 'html-classes';

interface Props {
  label: string;
  value?: boolean;
  onChange: (values: boolean) => void;
  className?: string;
  isCompact?: boolean;
}

const ProductExpressDeliveryFilter = ({
  label,
  value = false,
  onChange,
  className,
  isCompact,
}: Props) => {
  return (
    <label
      className={classes(['control__switch', 'checkbox-wrapper', className])}
    >
      <input
        onChange={() => onChange(!value)}
        checked={value}
        type="checkbox"
        className="control__switch-input"
        name="express"
      />
      <span className="control__switch-mark" />
      <div className="control__switch-text text-wrapper">
        <div className={classes(['description', isCompact && 'reversed'])}>
          {label}
        </div>
      </div>
    </label>
  );
};

export default ProductExpressDeliveryFilter;
